import * as Sentry from '@sentry/react';

import { router } from '@/router';

export interface SentryInitConfig {
  // Public client DSN. Undefined when the env var is unset (dev/test).
  dsn: string | undefined;
  // Pass import.meta.env.PROD — Sentry stays off in dev/test builds.
  enabled: boolean;
}

// Initializes Sentry error + performance monitoring. Returns true when Sentry
// was started, false when it was a no-op (disabled, or no DSN configured).
// Core Web Vitals (CLS, FCP, LCP, TTFB, and INP) are captured natively by the
// browser-tracing integration — no separate web-vitals package needed.
export function initSentry({ dsn, enabled }: SentryInitConfig): boolean {
  if (!enabled || !dsn) {
    return false;
  }

  Sentry.init({
    dsn,
    environment: 'production',
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });

  return true;
}
